const props: Record<string, Record<string, unknown>> = {
  MuiButtonBase: {
    disableRipple: false,
  },
  MuiCardHeader: {
    titleTypographyProps: { variant: "h6" },
  },
};

export default props;
